import { defineMessages } from '@jutro/locale';

export default defineMessages({
    documentNotFound: {
        id: 'ml.gateway.policyDocuments.Document not found for this category',
        defaultMessage: 'Document not found for this category'
    },
    new: {
        id: 'ml.gateway.policyDocuments.New',
        defaultMessage: 'New'
    },
    actionRequired: {
        id: 'ml.gateway.policyDocuments.Action Required',
        defaultMessage: 'Action Required'
    },
    type: {
        id: 'ml.gateway.policyDocuments.Type',
        defaultMessage: 'Type'
    },
    actions: {
        id: 'ml.gateway.policyDocuments.Actions',
        defaultMessage: 'Actions'
    },
    viewPrint: {
        id: 'ml.gateway.policyDocuments.View / Print',
        defaultMessage: 'View / Print'
    },
    viewDetails: {
        id: 'ml.gateway.policyDocuments.View Details',
        defaultMessage: 'View Details'
    },
    generating: {
        id: 'ml.gateway.policyDocuments.Generating...',
        defaultMessage: 'Generating...'
    },
    downloadError: {
        id: 'ml.gateway.policyDocuments.downloadError',
        defaultMessage: 'We were unable to download your document, please try again.'
    },
    policyNumber: {
        id: 'ml.gateway.policyDocuments.Policy #',
        defaultMessage: 'Policy #'
    },
    date: {
        id: 'ml.gateway.policyDocuments.Date',
        defaultMessage: 'Date'
    },
    documentName: {
        id: 'ml.gateway.policyDocuments.Document Name',
        defaultMessage: 'Document Name'
    },
    transactionType: {
        id: 'ml.gateway.policyDocuments.Transaction Type',
        defaultMessage: 'Transaction Type'
    },
    recipients: {
        id: 'ml.gateway.policyDocuments.Recipients',
        defaultMessage: 'Recipient(s)'
    },
    somethingWentWrong: {
        id: 'ml.gateway.policyDocuments.somethingWentWrong',
        defaultMessage: 'Something went wrong during this process. Please try again.'
    }
});